import(/* webpackMode: "eager" */ "/Users/arthurtanoh/Documents/Work/Bool technology/cosa/site/medservices/src/app/rendez-vous/page.tsx");
